import React from 'react'
import { Tooltip, Typography, makeStyles } from '@material-ui/core'

import { UnitMatchScore, matchScoreColor } from './occupancyMatchScoreUtils'

const useStyles = makeStyles({
    score: {
        width: 64,
        flexShrink: 0,
        fontSize: '0.75rem',
        fontWeight: 700,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
    },
    compact: {
        width: 'auto',
    },
})

export function OccupancyMatchScore({
    result,
    compact,
}: {
    result: UnitMatchScore
    compact?: boolean
}) {
    const classes = useStyles()
    return (
        <Tooltip
            title={
                <span style={{ whiteSpace: 'pre-line' }}>{result.tooltip}</span>
            }
        >
            <Typography
                className={`${classes.score} ${compact ? classes.compact : ''}`}
                style={{ color: matchScoreColor(result) }}
            >
                {result.label}
            </Typography>
        </Tooltip>
    )
}
